export const BREAKPOINT_TABLET = 600;
export const BREAKPOINT_DESKTOP = 1280;

export const CARD_WIDTH_TABLET = 380;
export const CARD_WIDTH_MOBILE = 325;